/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class SmartAssistantAlarmsStrService {
    get = this.i18nService.get;

    i18n = {
        helpTitle: this.get('monitor.alarmAndLog_simplifiedMode_collect_title'),
        detailLabel: this.get('system.upgrade_task_start_viewDetail_info'),
        infoCollect: this.get('monitor.alarmAndLog_simplifiedMode_infoCollect_btn'),
    };

    constructor(private i18nService: I18nService) { }
}
